import { useEffect } from 'react';

import SkcDevicesAutocomplete from './skcDevicesAutocomplete';
import useUrlSearchParamsSkcDevice from '../../hooks/useUrlSearchParamsSkcDevice';
import Device from '../../interfaces/device';

interface SkcDevicesFilterProps {
	defaultDeviceId?: string;
	organisationId?: string;
	count?: number;
	onChange?: (value: Device) => void;
}

const SkcDevicesFilter = ({
	defaultDeviceId,
	count = 10,
	onChange,
	organisationId,
	...skcDevicesAutocompleteProps
}: SkcDevicesFilterProps) => {
	const [device, setDevice] = useUrlSearchParamsSkcDevice();

	// TODO: this feels a bit tricky. Multiple sources of truth, look into
	// making this more reliable or taking the useUrlSearchParamsSkcDevice
	// as the source of truth
	useEffect(() => {
		if (!skcDevicesAutocompleteProps.value && device != null) {
			setDevice(null);
		}
	}, [skcDevicesAutocompleteProps.value, device, setDevice]);

	const handleChange = (value: Device) => {
		setDevice(value);
		onChange?.(value);
	};

	return (
		<SkcDevicesAutocomplete
			{...skcDevicesAutocompleteProps}
			value={device}
			organisationId={organisationId}
			onChange={(_, newValue) => handleChange(newValue)}
		/>
	);
};

export default SkcDevicesFilter;
